import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, Genre } from "../../types"
import { PAGE_SIZE, RECORD_MEDIA_TYPES } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Genre>()

export function TableGenres({
  genres,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  genres: Genre[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!genres) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [genres, count])

  return (
    <Table
      data={genres}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Nome"
        name="name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(genre) => (
          <Link to={`/genres/genres/${genre.id}`}>
            <LinkMagik className="text-dark">{genre.name}</LinkMagik>
          </Link>
        )}
        stickyLeft
        // TODO badge
      />
      <Table.Column
        title="Tipologia"
        name="record_media_type"
        sortable
        width="minmax(max-content, 1fr)"
        render={(genre: Genre) =>
          RECORD_MEDIA_TYPES.find((type) => type.value === genre.record_media_type)?.label || genre.record_media_type
        }
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} generi
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
